module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4a46aef47c55dcd1f6d89e7738a0b41b.png";